import { render, staticRenderFns } from "./PassengerInformation.vue?vue&type=template&id=b2c9ac68"
import script from "./PassengerInformation.vue?vue&type=script&lang=js"
export * from "./PassengerInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports